const items = [
  {
    title: "Posacenere Olivetti O",
    image: "https://cdn.shopify.com/s/files/1/0750/1414/4268/files/posacenere-olivetti.jpg?v=1736418946",
    author: "Giorgio Soavi - 1968",
    price: 200
  },
  {
    title: "Lampada Artemide Eclisse",
    image: "https://cdn.shopify.com/s/files/1/0750/1414/4268/files/artemide_eclisse.jpg?v=1736418946",
    author: "Vico Magistretti - 1965",
    price: 120
  },
  {
    title: "Cappellini Tube Chair",
    image: "https://cdn.shopify.com/s/files/1/0750/1414/4268/files/tube-chair-joe-colombo.jpg?v=1736418946",
    author: "Joe Colombo - 1969",
    price: 4000
  },
  {
    title: "Portasigarette vintage",
    image: "https://cdn.shopify.com/s/files/1/0750/1414/4268/files/portasigarette-vintage.jpg?v=1736418947",
    author: "Anonimo - 1960",
    price: 170
  },
  {
    title: "Contenitore Kartell",
    image: "https://cdn.shopify.com/s/files/1/0750/1414/4268/files/mobile-kartell.jpg?v=1736419391",
    author: "Anna Castelli Ferrieri - 1968",
    price: 110
  },
  {
    title: "Calendario Arlac Dati",
    image: "https://cdn.shopify.com/s/files/1/0750/1414/4268/files/arlac-dati-calendario-perpetuo.jpg?v=1736424191",
    author: "DBGM Design Halm - 1970",
    price: 70
  },
  {
    title: "Maledetta Primavera vinile 45 giri",
    image: "https://cdn.shopify.com/s/files/1/0750/1414/4268/files/maledetta-primavera-vinile.jpg?v=1736426203",
    author: "Loretta Goggi - 1981",
    price: 10
  },
  {
    title: "Sgabello Mezzadro Zanotta",
    image: "https://cdn.shopify.com/s/files/1/0750/1414/4268/files/zanotta-mezzadro-achille-castiglioni.jpg?v=1736425086",
    author: "Achille Castiglioni - 1957",
    price: 800
  },
  {
    title: "Vaso Love in Bloom Seletti",
    image: "https://cdn.shopify.com/s/files/1/0750/1414/4268/files/seletti-cuore.jpg?v=1736426651",
    author: "Marcantonio - 2018",
    price: 60
  },
  {
    title: "Macchina da scrivere Olivetti Valentine",
    image: "https://cdn.shopify.com/s/files/1/0750/1414/4268/files/ettore-sottsass-valentine.jpg?v=1736424675",
    author: "Ettore Sottsass - 1969",
    price: 400
  },
];

let currentRound = 0;
let score = 0;

function updateGameRound() {
  if (currentRound >= items.length) {
    document.getElementById("game-round").style.display = "none";
    document.getElementById("feedback").style.display = "none";
    document.getElementById("final-score").style.display = "block";
    document.getElementById("final-score-points").textContent = score;

    // Salva il punteggio finale nel localStorage
    localStorage.setItem("userScore", score);

    return;
  }

  const currentItem = items[currentRound];
  document.getElementById("item-title").textContent = currentItem.title;
  document.getElementById("item-author").textContent = currentItem.author;
  document.getElementById("item-image").src = currentItem.image;
  document.getElementById("item-image").alt = currentItem.title;
  document.getElementById("current-round").textContent = currentRound + 1;
  document.getElementById("total-rounds").textContent = items.length;
  document.getElementById("price-input").value = "";
  document.getElementById("price-input").disabled = false;
  document.getElementById("submit-guess").style.display = "block";
  document.getElementById("next-button").style.display = "none";
  document.getElementById("feedback-title").textContent = "Quanto vale questo oggetto?";
  document.getElementById("feedback-title").style.color = "";
}

document.getElementById("submit-guess").addEventListener("click", () => {
  const guessedPrice = parseFloat(document.getElementById("price-input").value);

  if (isNaN(guessedPrice)) {
    alert("Per favore, inserisci un numero valido.");
    return;
  }

  const currentItem = items[currentRound];
  const difference = Math.abs(guessedPrice - currentItem.price);
  const percentageDifference = (difference / currentItem.price) * 100;

  const feedbackTitle = document.getElementById("feedback-title");

  if (percentageDifference === 0) {
    feedbackTitle.textContent = "Prezzo esatto! Continua così :)";
    feedbackTitle.style.color = "green";
    score += 5;
  } else if (percentageDifference <= 15) {
    feedbackTitle.textContent = `Bravo! Il prezzo corretto è ${currentItem.price}€`;
    feedbackTitle.style.color = "green";
    score += 3;
  } else if (percentageDifference <= 25) {
    feedbackTitle.textContent = `Non male! Il prezzo corretto è ${currentItem.price}€`;
    feedbackTitle.style.color = "green";
    score += 1;
  } else {
    feedbackTitle.textContent = `Sbagliato! Il prezzo corretto è ${currentItem.price}€`;
    feedbackTitle.style.color = "red";
  }

  document.getElementById("score-points").textContent = score;

  // Salva il punteggio attuale
  localStorage.setItem("userScore", score);

  if (currentRound === items.length - 1) {
    document.getElementById("next-button").textContent = "Scopri il tuo premio";
    document.getElementById("next-button").onclick = () => {
      window.location.href = "/pages/premio-finale";
    };
  } else {
    document.getElementById("next-button").textContent = "Prossimo livello";
    document.getElementById("next-button").onclick = () => {
      currentRound++;
      updateGameRound();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
  }

  document.getElementById("submit-guess").style.display = "none";
  document.getElementById("next-button").style.display = "block";
});

updateGameRound();
